import * as Backbone from 'backbone';
import FilePreviewer from 'sma.common/components/file_previewer';

const ajax = require('sma.common/ajax');
const Alert = require('sma.admin/components/alert.js');
const modals = require('sma.common/components/modals');
const Dropdown = require('sma.admin/components/dropdowns/dropdown');

const uploadedFileTempl = require('sma.applicant/tasks/partials/uploaded_file.mustache');
const uploadProgressTempl = require('sma.applicant/tasks/partials/upload_progress.mustache');

const STRINGS = {
	added: gettext('Added'),
	edit: gettext('Edit'),
	filename: gettext('Filename'),
	linked_URL: gettext('URL'),
	preview: gettext('Preview'),
	download: gettext('Download'),
	remove: gettext('Remove'),
	file_upload_error_message: gettext('This file cannot be accessed due to a problem with the upload.')
};

class UploadTask extends Backbone.View {
	get events() {
		return {
			'click .sma-js-upload-video-link': 'uploadLink',
			'change #sma-js-files-upload-file': 'uploaderChanged',
			'click .sma-js-show-formats': 'showAcceptedFormats',
			'click .sma-js-task-upload-file-item': 'previewUploadFromRow'
		};
	}

	get $fileList() {
		return $('.sma-js-applicant-task-file-list');
	}

	initialize(config) {
		this.setElement($('body'));

		this.submission_id = config.submission_id;
		this.task_record_id = config.task_record_id;

		this.max_uploads = config.max_uploads || 9999;
		this.min_uploads = config.min_uploads || 1;
		this.file_formats = config.file_formats;
		this.limit_file_formats = config.limit_file_formats;

		this.load(this.render);
	}

	load(callback) {
		let url = reverse('task-file-attachment-list', {
			submission_id: this.submission_id,
			task_record_id: this.task_record_id
		});

		ajax.get({
			url: url,
			callback: (response) => {
				this.files = response.files;
				callback.apply(this);
			}
		});
	}

	fileIcon(type) {
		switch (type) {
			case 'file':
				return 'files_single-content-03';
			case 'image':
				return 'files_image';
			case 'video':
				return 'files_play';
			case 'audio':
				return 'files_music';
			case 'link':
				return 'ui-2_link-72';
			default:
				return 'files_single-folded';
		}
	}

	render() {
		let disabled = this.max_uploads > 0 && this.files.length >= this.max_uploads;

		let task_completed = this.files.length >= this.min_uploads && this.files.length <= this.max_uploads;

		$('.sma-js-upload-video-link')
			.prop('disabled', disabled)
			.toggleClass('disabled', disabled)
			.parent().toggleClass('disabled', disabled);

		$('#sma-js-files-upload-file')
			.prop('disabled', disabled)
			.toggleClass('disabled', disabled);

		$('#sma-btn-attach-file').toggleClass('disabled', disabled);

		$('.sma-js-mark-complete')
			.prop('disabled', !task_completed)
			.toggleClass('disabled', !task_completed);

		this.$fileList.empty();

		this.files.forEach((file, i) => {
			const fileUrl = new URL(file.url, location);
			file.icon = this.fileIcon(file.type);
			// Extract extension from fileUrl.pathname and combine with file.name
			const extensionIndex = fileUrl.pathname.lastIndexOf('.');
			const extension = extensionIndex !== -1 ? fileUrl.pathname.substring(extensionIndex) : '';
			file.filename = file.name + extension;

			this.$fileList.append(uploadedFileTempl({ file, STRINGS }));

			let items = [{
				name: 'edit',
				text: STRINGS.edit,
				action: (_data) => {
					this.editUpload(file);
				}
			}, {
				name: 'preview',
				text: STRINGS.preview,
				action: (_data) => {
					this.index = i;
					this.previewUpload();
				}
			}, {
				name: 'remove',
				text: STRINGS.remove,
				action: (_data) => {
					this.removeUpload(file);
				}
			}];

			if (file.type !== 'link') {
				items.push({
					name: 'download',
					text: STRINGS.download,
					attribute: `download=${file.filename}`,
					href: file.url,
					action: (_data) => { }
				});
			}

			let dropdown = new Dropdown({
				items: items,
				title: '<i class="nc-icon-mini ui-2_menu-dots" aria-hidden="true"></i>',
				noCaret: true,
				btnclass: 'btn-link btn-crammed',
				rightAligned: true,
				ariaLabel: gettext('Perform action on uploaded file'),
			}).$el.addClass('dropdown');

			this.$fileList.find(`.sma-js-task-file-actions[data-id="${file.id}"]`).html(dropdown);
		});
	}

	previewUploadFromRow(e) {
		// If the dropdown was clicked, bail
		if ($(e.target).closest('.sma-js-task-file-actions').length > 0) {
			return;
		} else {
			let fileId = $(e.currentTarget).data('id');
			this.index = this.files.findIndex((file) => {
				return file.id === fileId;
			});

			this.previewUpload();
		}
	}

	previewUpload() {
		this.load(this.createFilePreviewer);
	}

	createFilePreviewer() {
		let config = {
			indexOfActiveFile: this.index,
			submissionId: this.submission_id,
			files: this.files
		};
		new FilePreviewer(config);
	}

	removeUpload(file) {
		let url = reverse('task-file-attachment-delete', {
			submission_id: this.submission_id,
			task_record_id: this.task_record_id,
			file_attachment_id: file.id
		});

		new modals.Confirm(
			gettext('Remove upload'),
			gettext('Are you sure you want to remove this upload?'),
			() => {
				ajax.post({
					url: url,
					callback: (_response) => {
						this.load(this.render);
					}
				});
			}
		);
	}

	uploadLink(_e) {
		let that = this;

		let modal = new modals.AjaxFormModal({
			destroyOnClose: true,
			title: gettext('Add a link'),
			onSuccess: () => {
				modal.hide();
				that.load(this.render);
			},
		});

		let url = reverse('task-file-upload-link', {
			submission_id: this.submission_id,
			task_record_id: this.task_record_id
		});

		modal.addToStack(
			'UploadLink',
			new modals.AjaxFormContent(url, {
				onLoad: () => { modal.show(); },
				buttons: [
					{
						label: gettext('Cancel'),
						cls: 'btn btn-link btn-loud',
						handler: (modal) => {
							modal.hide();
						},
					}, {
						label: gettext('Ok'),
						type: 'submit',
						cls: 'btn btn-primary btn-loud',
						handler: (modal) => {
							modal.modalBody.find('form').submit();
						},
					},
				],
			}),
		);
	}

	editUpload(file) {
		let modal = new modals.AjaxFormModal({
			destroyOnClose: true,
			title: file.type == 'link' ? gettext('Edit link') : gettext('Edit file'),
			onSuccess: () => {
				modal.hide();
				this.load(this.render);
			},
		});

		let url = reverse(file.type == 'link' ? 'task-file-edit-link' : 'task-file-edit-file', {
			submission_id: this.submission_id,
			task_record_id: this.task_record_id,
			file_attachment_id: file.id
		});

		modal.addToStack(
			'UploadLink',
			new modals.AjaxFormContent(url, {
				onLoad: () => { modal.show(); },
				buttons: [
					{
						label: gettext('Cancel'),
						cls: 'btn btn-link btn-loud',
						handler: (modal) => {
							modal.hide();
						}
					}, {
						label: gettext('Ok'),
						type: 'submit',
						cls: 'btn btn-primary btn-loud',
						handler: (modal) => {
							modal.modalBody.find('form').submit();
						}
					}
				]
			})
		);
	}

	showAcceptedFormats(e) {
		e.preventDefault();

		$('.sma-js-show-formats').hide();
		$('.sma-js-accepted-formats').show();
	}

	uploaderChanged(e) {
		const files = e.target.files;

		$.each(files, (key, file) => {
			const match = file.name.match(/\.([^\.]+)$/);
			let ext = '';

			if (match) {
				ext = match[1];
			}

			if (this.limit_file_formats && $.inArray(ext.toLowerCase(), this.file_formats) == -1) {
				new Alert({
					type: 'warning',
					message: gettext('Wrong file format!')
				});
				return;
			}

			let data = new FormData();
			data.append('file', file);

			let progressData = {
				$el: $(uploadProgressTempl({
					strings: {
						uploading: gettext('Uploading'),
						cancel: gettext('Cancel')
					}
				})),
				$container: $('.sma-js-file-upload-progress'),
				filename: file.name,
			};

			let url = reverse('task-file-upload-file', {
				submission_id: this.submission_id,
				task_record_id: this.task_record_id
			});

			ajax.post({
				url: url,
				data: data,
				cache: false,
				datatype: 'json',
				processData: false,
				contentType: false,
				progressBar: true,
				progressData: progressData,
				callback: (_result) => {
					this.load(this.render);

					setTimeout(() => {
						progressData.$el.slideUp(500, () => {
							progressData.$el.remove();
						});
					}, 3000);
				},
			});
		});

		$('.sma-js-file-upload-progress').val('');

		// resets the file input so that reuploading the same file triggers a change event
		$('#sma-js-files-upload-file').val('');
	}
}

class UploadTaskReadOnly extends Backbone.View {
	get events() {
		return {
			'click .sma-js-task-upload-file-item': 'previewUploadFromRow'
		};
	}

	initialize(config) {
		this.setElement($('body'));

		this.files = config.files;
		this.submission_id = config.submission_id;
		this.task_record_id = config.task_record_id;

		this.render();
	}

	get $fileList() {
		return $('.sma-js-applicant-task-file-list');
	}

	fileIcon(type) {
		switch (type) {
			case 'file':
				return 'files_single-content-03';
			case 'image':
				return 'files_image';
			case 'video':
				return 'files_play';
			case 'audio':
				return 'files_music';
			case 'link':
				return 'ui-2_link-72';
			default:
				return 'files_single-folded';
		}
	}

	render() {
		this.$fileList.empty();
		this.files.forEach((file, i) => {
			const fileUrl = new URL(file.url, location);
			file.icon = this.fileIcon(file.type);
			// Extract extension from fileUrl.pathname and combine with file.name
			const extensionIndex = fileUrl.pathname.lastIndexOf('.');
			const extension = extensionIndex !== -1 ? fileUrl.pathname.substring(extensionIndex) : '';
			file.filename = file.name + extension;

			this.$fileList.append(uploadedFileTempl({ file, STRINGS }));

			let items = [{
				name: 'preview',
				text: STRINGS.preview,
				action: (_data) => {
					this.previewUpload(i, this.files);
				}
			}];

			if (file.type !== 'link') {
				items.push({
					name: 'download',
					text: STRINGS.download,
					attribute: `download=${file.filename}`,
					href: file.url,
					action: (_data) => { }
				});
			}

			let dropdown = new Dropdown({
				items: items,
				title: '<i class="nc-icon-mini ui-2_menu-dots" aria-hidden="true"></i>',
				noCaret: true,
				btnclass: 'btn-link btn-crammed',
				rightAligned: true,
				ariaLabel: gettext('Perform action on uploaded file'),
			}).$el.addClass('dropdown');

			this.$fileList.find(`.sma-js-task-file-actions[data-id="${file.id}"]`).html(dropdown);
		});
	}

	previewUpload(index, files) {
		let config = {
			indexOfActiveFile: index,
			files: files,
			submissionId: this.submission_id,
			taskRecordId: this.task_record_id
		};

		new FilePreviewer(config);
	}

	previewUploadFromRow(e) {
		// If the dropdown was clicked, bail
		if ($(e.target).closest('.sma-js-task-file-actions').length > 0) {
			return;
		} else {
			let fileId = $(e.currentTarget).data('id');
			let index = this.files.findIndex((file) => {
				return file.id === fileId;
			});

			this.previewUpload(index, this.files);
		}
	}
}

module.exports = {
	UploadTask: UploadTask,
	UploadTaskReadOnly: UploadTaskReadOnly
};
